import 'zone.js/plugins/zone-error';

export const environment = {
  production: false,
  local: false,
  baseURL: 'https://teste.packboo.com/api',
  apiDoc: 'https://teste.packboo.com/swagger-ui/index.html',
  version: require('../../package.json').version
};
